// ================================================================================
// monaco editor (used in vs code)
// ================================================================================
// import React, { useState, useEffect } from 'react';
// import HtmlEditor from './HtmlEditor';

// function PreviewModal({ theme, templateId, templateHtmlCache, onHtmlEdit, onClose }) {
//   const [isEditing, setIsEditing] = useState(false);

//   // Get cached data for current template
//   const cachedData = templateHtmlCache[templateId];
//   const displayHtml = cachedData?.edited || cachedData?.generated || '';

//   const handleEditClick = () => {
//     setIsEditing(true);
//   };

//   const handleSaveEdit = (editedHtml) => {
//     if (!editedHtml || !editedHtml.trim()) {
//       alert('HTML cannot be empty!');
//       return;
//     }
    
//     console.log('💾 Saving edited HTML to cache, length:', editedHtml.length);
//     onHtmlEdit(editedHtml);
//     setIsEditing(false);
//   };

//   const handleCancelEdit = () => {
//     const confirmDiscard = window.confirm('Discard all changes and return to preview?');
//     if (confirmDiscard) {
//       setIsEditing(false);
//     }
//   };

//   const handleModalClose = () => {
//     if (isEditing) {
//       const confirmClose = window.confirm('Close editor without saving? All changes will be lost.');
//       if (!confirmClose) return;
//     }
    
//     setIsEditing(false);
//     onClose();
//   };

//   const handleBackdropClick = (e) => {
//     if (e.target.className === 'preview-modal-overlay') {
//       handleModalClose();
//     }
//   };

//   // Keyboard shortcut for Escape to close (only in preview mode)
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'Escape' && !isEditing) {
//         onClose();
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [isEditing, onClose]);

//   if (!displayHtml) {
//     return null;
//   }

//   return (
//     <div className="preview-modal-overlay" onClick={handleBackdropClick}>
//       <div className="preview-modal-container" onClick={(e) => e.stopPropagation()}>
//         {/* SINGLE HEADER - Buttons toggle based on isEditing */}
//         <div className="preview-modal-header">
//           <div className="preview-modal-title">
//             <span className="theme-icon">{theme.icon}</span>
//             <div>
//               <h3>{isEditing ? 'Edit HTML' : 'Preview'}: {theme.name}</h3>
//               <p className="preview-modal-subtitle">
//                 {isEditing 
//                   ? 'Make changes to your HTML code below' 
//                   : cachedData?.edited 
//                     ? 'Showing edited version' 
//                     : 'Showing AI-generated version'
//                 }
//               </p>
//             </div>
//           </div>
          
//           {/* TOGGLE BUTTONS - Same header, different buttons */}
//           <div className="preview-modal-actions">
//             {isEditing ? (
//               <>
//                 {/* EDITING MODE: Save & Cancel */}
//                 <button 
//                   className="btn-custom btn-save-editor"
//                   onClick={() => {
//                     // Get current value from Monaco editor
//                     const editor = window.monacoEditorInstance;
//                     if (editor) {
//                       const currentValue = editor.getValue();
//                       handleSaveEdit(currentValue);
//                     }
//                   }}
//                   title="Save changes and update preview"
//                 >
//                   <span className="icon">💾</span>
//                   Save
//                 </button>
//                 <button 
//                   className="btn-custom btn-cancel-editor" 
//                   onClick={handleCancelEdit}
//                   title="Discard changes"
//                 >
//                   <span className="icon">✕</span>
//                   Cancel
//                 </button>
//               </>
//             ) : (
//               <>
//                 {/* PREVIEW MODE: Edit & Close */}
//                 <button 
//                   className="btn-custom btn-edit"
//                   onClick={handleEditClick}
//                   title="Edit HTML"
//                 >
//                   <span className="icon">✏️</span>
//                   Edit
//                 </button>
//                 <button 
//                   className="btn-custom btn-close-modal"
//                   onClick={handleModalClose}
//                   title="Close"
//                 >
//                   <span className="icon">✕</span>
//                   Close
//                 </button>
//               </>
//             )}
//           </div>
//         </div>

//         {/* BODY - Monaco Editor or Preview */}
//         <div className="preview-modal-body">
//           {isEditing ? (
//             <HtmlEditor
//               html={displayHtml}
//               onSave={handleSaveEdit}
//               onCancel={handleCancelEdit}
//             />
//           ) : (
//             <div className="preview-iframe-container">
//               <iframe
//                 srcDoc={displayHtml}
//                 title="Website Preview"
//                 className="preview-iframe"
//                 sandbox="allow-same-origin allow-scripts allow-forms"
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default PreviewModal;



// ================================================================================
// inline editor version
// ================================================================================
import React, { useState, useEffect, useRef } from 'react';

function PreviewModal({ theme, templateId, templateHtmlCache, onHtmlEdit, onClose }) {
  const [isEditing, setIsEditing] = useState(false);
  const iframeRef = useRef(null);

  // Get cached data for current template
  const cachedData = templateHtmlCache[templateId];
  const displayHtml = cachedData?.edited || cachedData?.generated || '';

  // Setup iframe - different behavior for preview vs edit mode
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      const doc = iframe.contentDocument;
      if (!doc || !doc.body) return;

      if (!isEditing) {
        // ============ PREVIEW MODE ============
        doc.body.contentEditable = false;
        doc.body.style.cursor = 'default';
        
        // Remove any existing editing styles
        const existingStyle = doc.getElementById('editing-styles');
        if (existingStyle) {
          existingStyle.remove();
        }
        
        // Enable smooth scrolling for anchor links
        const anchorLinks = doc.querySelectorAll('a[href^="#"]');
        anchorLinks.forEach(link => {
          const newLink = link.cloneNode(true);
          link.parentNode.replaceChild(newLink, link);
          
          newLink.addEventListener('click', (e) => {
            e.preventDefault();
            const href = newLink.getAttribute('href');
            if (!href) return; // ✅ Safety check
            
            const targetId = href.substring(1);
            const targetElement = doc.getElementById(targetId);
            if (targetElement) {
              targetElement.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
              });
            }
          });
        });
      } else {
        // ============ EDIT MODE ============
        doc.body.contentEditable = true;
        doc.body.style.outline = 'none';
        doc.body.style.cursor = 'text';
        
        // ✅ PREVENT ALL NAVIGATION IN EDIT MODE
        const allLinks = doc.querySelectorAll('a');
        allLinks.forEach(link => {
          // Remove the href temporarily to prevent navigation
          const originalHref = link.getAttribute('href');
          if (originalHref) {
            link.setAttribute('data-original-href', originalHref);
            link.removeAttribute('href');
          }
          
          // Prevent click
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          });
          
          // Make link look like text during editing
          link.style.cursor = 'text';
        });
        
        // Add editing styles
        const existingStyle = doc.getElementById('editing-styles');
        if (existingStyle) {
          existingStyle.remove();
        }
        
        const style = doc.createElement('style');
        style.id = 'editing-styles';
        style.textContent = `
          body {
            cursor: text !important;
          }
          *:hover {
            outline: 2px dashed #5570f1 !important;
            outline-offset: 2px;
          }
          *:focus {
            outline: 2px solid #28a745 !important;
            outline-offset: 2px;
          }
          a {
            cursor: text !important;
            pointer-events: auto !important;
          }
        `;
        doc.head.appendChild(style);
        
        doc.body.focus();
        console.log('✅ Edit mode: Navigation disabled, found', allLinks.length, 'links');
      }
    };
    
    iframe.addEventListener('load', handleLoad);
    handleLoad();
    
    return () => iframe.removeEventListener('load', handleLoad);
  }, [isEditing, displayHtml]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveEdit = () => {
    const iframe = iframeRef.current;
    
    if (iframe && iframe.contentDocument) {
      const doc = iframe.contentDocument;
      
      // Restore hrefs before saving
      const allLinks = doc.querySelectorAll('a[data-original-href]');
      allLinks.forEach(link => {
        const originalHref = link.getAttribute('data-original-href');
        link.setAttribute('href', originalHref);
        link.removeAttribute('data-original-href');
        link.style.removeProperty('cursor');
      });
      
      // Disable editing
      doc.body.contentEditable = false;
      doc.body.style.cursor = 'default';
      
      // Remove editing styles
      const existingStyle = doc.getElementById('editing-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      // Clean up HTML - Remove contentEditable attributes
      const allElements = doc.querySelectorAll('[contenteditable]');
      allElements.forEach(element => {
        element.removeAttribute('contenteditable');
      });
      
      // Remove inline styles from body
      if (doc.body.hasAttribute('style')) {
        const bodyStyle = doc.body.style;
        bodyStyle.removeProperty('outline');
        bodyStyle.removeProperty('cursor');
        
        if (bodyStyle.length === 0) {
          doc.body.removeAttribute('style');
        }
      }
      
      // Extract cleaned HTML
      const doctype = '<!DOCTYPE html>';
      const htmlContent = doc.documentElement.outerHTML;
      const fullHtml = doctype + '\n' + htmlContent;
      
      console.log('💾 Saving cleaned HTML, length:', fullHtml.length);
      
      // Verify clean
      if (fullHtml.includes('contenteditable')) {
        console.warn('⚠️ Warning: HTML still contains contenteditable');
      } else {
        console.log('✅ HTML is clean');
      }
      
      // Send to parent
      onHtmlEdit(fullHtml);
      
      // Exit edit mode
      setIsEditing(false);
    }
  };

  const handleCancelEdit = () => {
    const confirmDiscard = window.confirm('Discard all changes and return to preview?');
    if (confirmDiscard) {
      const iframe = iframeRef.current;
      if (iframe && iframe.contentDocument) {
        const doc = iframe.contentDocument;
        doc.body.contentEditable = false;
        doc.body.style.cursor = 'default';
        
        const existingStyle = doc.getElementById('editing-styles');
        if (existingStyle) {
          existingStyle.remove();
        }
      }
      
      setIsEditing(false);
      
      // Force reload to reset changes
      setTimeout(() => {
        if (iframeRef.current) {
          const currentSrc = iframeRef.current.srcdoc;
          iframeRef.current.srcdoc = '';
          setTimeout(() => {
            if (iframeRef.current) {
              iframeRef.current.srcdoc = currentSrc;
            }
          }, 10);
        }
      }, 10);
    }
  };

  const handleModalClose = () => {
    if (isEditing) {
      const confirmClose = window.confirm('Close without saving? All changes will be lost.');
      if (!confirmClose) return;
    }
    
    setIsEditing(false);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target.className === 'preview-modal-overlay') {
      handleModalClose();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && !isEditing) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isEditing, onClose]);

  if (!displayHtml) {
    return null;
  }

  return (
    <div className="preview-modal-overlay" onClick={handleBackdropClick}>
      <div className="preview-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="preview-modal-header">
          <div className="preview-modal-title">
            <span className="theme-icon">{theme.icon}</span>
            <div>
              <h3>{isEditing ? 'Edit Content' : 'Preview'}: {theme.name}</h3>
              <p className="preview-modal-subtitle">
                {isEditing 
                  ? 'Click on any text to edit it directly' 
                  : cachedData?.edited 
                    ? 'Showing edited version' 
                    : 'Showing AI-generated version'
                }
              </p>
            </div>
          </div>
          
          <div className="preview-modal-actions">
            {isEditing ? (
              <>
                <button 
                  className="btn-custom btn-save-editor"
                  onClick={handleSaveEdit}
                  title="Save changes"
                >
                  <span className="icon">💾</span>
                  Save
                </button>
                <button 
                  className="btn-custom btn-cancel-editor" 
                  onClick={handleCancelEdit}
                  title="Discard changes"
                >
                  <span className="icon">✕</span>
                  Cancel
                </button>
              </>
            ) : (
              <>
                <button 
                  className="btn-custom btn-edit"
                  onClick={handleEditClick}
                  title="Edit content"
                >
                  <span className="icon">✏️</span>
                  Edit
                </button>
                <button 
                  className="btn-custom btn-close-modal"
                  onClick={handleModalClose}
                  title="Close"
                >
                  <span className="icon">✕</span>
                  Close
                </button>
              </>
            )}
          </div>
        </div>

        <div className="preview-modal-body">
          <div className="preview-iframe-container">
            {isEditing && (
              <div className="edit-instructions">
                <span className="icon">ℹ️</span>
                <span>Click on any text to edit. Links are disabled during editing.</span>
              </div>
            )}
            <iframe
              ref={iframeRef}
              srcDoc={displayHtml}
              title="Website Preview"
              className={`preview-iframe ${isEditing ? 'editing-mode' : ''}`}
              sandbox="allow-same-origin allow-scripts allow-forms"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreviewModal;